<template>
  <div class="text-center py-11" :style="componentStyle">
    <v-container>
      <h1 class="PageBreak__header"><slot name="header" /></h1>

      <div class="PageBreak__body mt-5">
        <slot name="body" />
      </div>
    </v-container>
  </div>
</template>

<script>
export default {
  name: "PageBreak",

  props: {
    componentStyle: {
      type: String,
    },
  },
};
</script>

<style>
.PageBreak__header {
  letter-spacing: -1.2px;
  line-height: 95%;
}

@media (max-width: 960px) {
  /* below laptop */
}

@media (min-width: 960px) {
  /* laptop and above */
  .PageBreak__header {
    letter-spacing: -1.2px;
    line-height: 95%;
  }
}
</style>
